import React from "react";
import NavBar from "../Components/NavBar";
import HeroSection from "../Components/HeroSection";
import OurServices from "../Components/OurServices";
import HowitWorks from "../Components/HowitWorks";
import GetinTouch from "../Components/GetinTouch";
import FooterIllus from "../Components/FooterIllus";
import Footer from "../Components/Footer";

const LandingPage: React.FC = () => {
  return (
    <div>
      <NavBar />
      <HeroSection />
      <OurServices />
      <HowitWorks />
      <GetinTouch />
      <FooterIllus />
      <Footer />
    </div>
  );
};

export default LandingPage;
